<script lang="ts" module>
	export interface Badge {
		color: string;
		index: number;
		subIndex?: string;
	}
</script>

<script lang="ts">
	import IconGlobe from 'virtual:icons/material-symbols/language';
	import IconDocument from 'virtual:icons/material-symbols/description';
	import { darkenColor } from '../util/colors';
	import { getWindowContext } from '@astlai/common/contexts/window.context.svelte';
	interface Props {
		badge: Badge;
		webSource?: boolean;
		appearance?: 'large' | 'default' | 'minimal';
	}
	let { badge, webSource = false, appearance = 'default' }: Props = $props();

	const wCtx = getWindowContext();
	const isDark = $derived(wCtx.theme !== 'light');
	const textColor = $derived(darkenColor(badge.color, isDark));
</script>

<div
	style="background-color: {appearance !== 'minimal' && badge.color}; color: {textColor};"
	class="source-badge"
	class:webSource
	class:large={appearance === 'large'}
	class:minimal={appearance === 'minimal'}
>
	{#if webSource}
		<IconGlobe />
	{:else}
		<IconDocument />
	{/if}
	<span>
		{badge.index}{badge.subIndex ?? ''}
	</span>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.source-badge {
		flex: 0 0 auto;
		font-size: 0.75rem;
		padding: 0.25rem 0.375rem 0.25rem 0.25rem;
		border-radius: 0.5rem;
		background: var(--surface-overlay-subtle);
		box-shadow: inset 0 0 0 1px var(--border-subtle);
		@include lib.inline-flex-row();
		@include lib.flex-align();
		gap: 0.25rem;
		font-size: 0.75rem;
		span {
			font-size: 0.75rem;
			line-height: 0.75rem;
		}

		&.large {
			font-size: 0.875rem;
			padding: 0.5rem 0.625rem 0.5rem 0.5rem;
			gap: 0.25rem;
			border-radius: 0.5rem;

			span {
				font-size: 0.875rem;
				line-height: 0.875rem;
			}
		}

		&.minimal {
			font-size: 0.75rem;
			padding: 0;
			gap: 0.125rem;
			border-radius: 0;
			box-shadow: none;
			background: transparent;
			vertical-align: middle;
			margin-right: 0.25rem;
			padding-bottom: 1px;

			span {
				font-size: 0.75rem;
				line-height: normal;
				font-weight: 500;
			}
		}
	}
</style>
